import React from "react"

import "./index.css"

export const ArrowLeft = ({ isColored=false }) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke={isColored ? '#F5333F':'fff'}
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="transition feather feather-arrow-left-circle"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 19.5L8.25 12l7.5-7.5"
            />
        </svg>
    )
}

export const ArrowRight = ({ isColored=false }) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke={isColored ? '#F5333F':'fff'}
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="transition feather feather-arrow-right-circle"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
            />
        </svg>
    )
}

export const CustomArrowLeft = () => (
    <div className="relative">
        <div className="arrow-left--custom"></div>
        <div className="arrow-left--custom__line"></div>
    </div>
)